import { axios } from '../../../utils/axios';
import { showAlert } from '../../../utils/alerts';

export const fetchAvicChannels = async (payload) => {
  try {
    const { data } = await axios.post('/costing-request/avic-extention', payload);
    return data;
  } catch (e) {
    showAlert(e, 'error');
  }
};

export const fetchAvicRequest = async (requestId) => {
  try {
    const { data } = await axios.get(`/costing-request/avic-extention/${requestId}`);

    return data.data.extention;
  } catch (e) {
    showAlert(e, 'error');
  }
};

export const submitAvicChannels = async (payload) => {
  try {
    const { data } = await axios.post('/costing-request/step/avic-extention-submit', {
      records: payload,
    });
    return data;
  } catch (e) {
    throw e;
  }
};

export const updateAvicRequest = async (payload) => {
  try {
    const { data } = await axios.post('/costing-request/step/avic-extention-update', payload);
    return data;
  } catch (e) {
    showAlert(e, 'error');
  }
};

export const fetchCountries = async () => {
  try {
    const { data } = await axios.get('/costing-request/distinct-countries');
    const countries = (data.data || []).filter((country) => country.PlantPrefix);

    return countries.map((item) => {
      return {
        label: item.Country,
        value: item.PlantPrefix,
      };
    });
  } catch (e) {
    showAlert(e, 'error');
  }
};

export const fetchSalesOrgs = async () => {
  try {
    const { data } = await axios.get(`/costing-request/sales-orgs`);
    return data?.data || [];
  } catch (e) {
    showAlert(e, 'error');
  }
};

export const getSubmitPayload = (channels, countries, countryCode) => {
  const payload = [];
  const country = countries.find((country) => country.value === countryCode);
  channels.forEach((channel) => {
    if (!channel.existing) {
      payload.push({
        ...channel,
        id: undefined,
        country: country.label,
      });
    }
  });

  return payload;
};
